<template>
  <div class="page-container">
    <van-image class="integral-bg" :src="integralBg" width="100%" />
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="top-box">
        <div class="warn-box" v-if="integralInfo.is_max === 1">
          <van-icon class="gold-coin" :name="GoldCoin" :size="transPxToRem(20)" />
          <div>今日{{ integralName }}获取已达上限</div>
        </div>
        <div class="integral-balance-box">
          <div class="box-title-wrp" v-if="!isUsedOfPage">
            <div class="box-title">{{ integralName }}账户余额</div>
            <div class="suffix-text" @click="isRulesPop = true">
              规则<van-icon name="question-o" :size="transPxToRem(10)" />
            </div>
          </div>
          <div class="has-use-title" v-else>已使用{{ integralName }}</div>
          <div class="balance-box">
            <div class="balance-count">
              {{ isUsedOfPage ? integralInfo.consume_integral : integralInfo.integral_balance }}
            </div>
          </div>
          <van-image class="big-gold-coin" :src="BigGoldCoin" :width="transPxToRem(88)" :height="transPxToRem(120)" />
        </div>
        <div class="integral-column" v-if="!isUsedOfPage">
          <div v-for="item in IntegralColumn" :key="item.key">
            <div class="count">{{ integralInfo[item.key] }}</div>
            <div @click="goUsedIntegral(item.key === UseIntegralKeyEnum.USE_ED)">
              {{ item.label }}{{ integralName }} <van-icon v-if="item.key === UseIntegralKeyEnum.USE_ED" name="arrow" />
            </div>
          </div>
        </div>
      </div>
      <div class="content-box">
        <van-sticky>
          <IntegralScreeBox @search="search" :isShowIncomeAndExpend="!isUsedOfPage" />
        </van-sticky>
        <van-list
          class="list-container"
          v-model:loading="loading"
          :finished="finished"
          :finished-text="finishedText"
          :immediate-check="false"
          @load="getList"
        >
          <div v-for="item in list" :key="item.rid" class="list-item-wrp">
            <div class="list-item-content">
              <div class="integral-content-box">
                <div class="integral-type-title">
                  <div class="integral-type-text">{{ item.integral_type_msg }}</div>
                  <div
                    class="income-type-tag"
                    :class="{
                      'effect-tag': item.status === IntegralStatusEnum.HAS_EFFECT,
                      'not-effect-tag': [IntegralStatusEnum.ORDER_CANCEL, IntegralStatusEnum.NOT_EFFECT].includes(
                        item.status
                      ),
                      'checking-tag': item.status === IntegralStatusEnum.WAIT_CHECK,
                      'success-tag': [IntegralStatusEnum.ORDER_SUCCESS, IntegralStatusEnum.HAS_SUCCESS].includes(
                        item.status
                      ),
                      'refuse-tag': item.status === IntegralStatusEnum.HAS_REFUSE,
                      'back-tag':
                        item.status ===
                        [IntegralStatusEnum.RECHARGE_BACK, IntegralStatusEnum.CANCEL_ORDER_BACK].includes(item.status)
                    }"
                  >
                    {{ item.status_msg }}
                  </div>
                </div>
                <div class="created-time-box">
                  <div class="created-time">{{ item.created_time }}</div>
                  <!-- <div class="created-time-allow">更多 <van-icon name="arrow" /></div> -->
                </div>
                <div class="order-type-box" v-if="[9, 10, 11, 16, 20, 23].includes(item.integral_type)">
                  <span>{{ item.remark }}</span>
                  &nbsp;&nbsp;
                  <SvgIcon
                    v-if="item.remark.indexOf('D') === 0 || item.remark.indexOf('J') === 0"
                    name="icon-fuzhi"
                    @click="copyInfo(item.remark)"
                    size="0.64rem"
                    :color="theme?.CopyIconColor"
                  />
                </div>
                <div class="user-info">
                  <van-image
                    :src="item.avatar_url || 'https://x.jzbull.com/x_dsx_wxadmin/default-head.png'"
                    :width="transPxToRem(23)"
                    :height="transPxToRem(23)"
                    round
                  />
                  <div class="user-name">
                    {{ item.nickname }}<template v-if="item.mobile">({{ item.mobile }})</template>
                  </div>
                </div>
              </div>
              <div class="integral-box">{{ item.integral }}</div>
            </div>
          </div>
        </van-list>
        <van-empty
          v-if="list.length == 0 && !loading"
          image-size="240"
          image="https://i.xurl.cn/x_dsx_wxapp/empty/result.png"
          description="暂无数据"
        />
      </div>
      <van-popup v-model:show="isRulesPop" round closeable position="bottom" safe-area-inset-bottom>
        <div class="integral-rule-box">
          <div class="integral-rule-title">{{ integralName }}规则</div>
          <div class="integral-get-title">{{ integralName }}获取方式:</div>
          <div class="integral-get-type" v-for="item in integralRules.integralScene" :key="item.name">
            <div>{{ item.name }}</div>
            <div>{{ item.integral }}分</div>
          </div>
          <div class="integral-flex">
            <div>{{ integralName }}生效期：</div>
            <div>{{ integralRules.effectDay }}</div>
          </div>
          <div class="integral-flex">
            <div>{{ integralName }}兑换比例：</div>
            <div>{{ integralRules.integralExchangeRation }}:1</div>
          </div>
          <div class="integral-flex">
            <div class="flex-shrink-0">{{ integralName }}有效期：</div>
            <div>{{ integralRules.expireDesc }}</div>
          </div>
        </div>
      </van-popup>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive, computed, unref } from 'vue'
import { Toast } from '@vant/compat'
import SvgIcon from '@/components/SvgIcon.vue'
import integralBg from '@/assets/img/integral_bg.png'
import BigGoldCoin from '@/assets/img/big_gold_coin.png'
import GoldCoin from '@/assets/img/gold_coin.png'
import { transPxToRem } from '@/utils'
import { useUserStore } from '@/store/user'
import { IntegralColumn, IntegralStatusEnum, UseIntegralKeyEnum } from './integral.data'
import { getIntegralCentreInfoApi, getIntegralListApi, getIntegralRuleApi } from '@/api/integral'
import IntegralScreeBox from './component/IntegralScreeBox.vue'
import usePage from '@/hooks/usePage'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'
import { onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'

const { navigateTo } = usePage()
const userStore = useUserStore()
const integralName = userStore.getProjectInfo?.integralName
const theme = computed(() => userStore.getTheme)

const { clipboardRef, copiedRef } = useCopyToClipboard()
const copyInfo = orderSn => {
  clipboardRef.value = orderSn
  unref(copiedRef) && Toast.success('复制成功')
}

const props = defineProps({
  isUsedOfPage: {
    type: Boolean,
    default: false
  }
})

const pageParams = reactive({
  page: 1,
  pageSize: 20
})
const postParams = ref({})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const reset = () => {
  finished.value = false
  list.value = []
  pageParams.page = 1
}

const search = params => {
  postParams.value = params
  reset()
  getList()
}

const getList = async () => {
  loading.value = true
  try {
    const resData = await getIntegralListApi({ ...pageParams, ...postParams.value })
    list.value.push(...resData.list)
    pageParams.page++
    finished.value = list.value.length === Number(resData.total)
  } catch {
    finished.value = true
  } finally {
    loading.value = false
  }
}

const integralInfo = ref({})

const goUsedIntegral = isGo => {
  isGo && navigateTo('/integral/integralUsed')
}

const refreshing = ref(false)
const onRefresh = async () => {
  refreshing.value = true
  try {
    getIntegralCentreInfo()
    reset()
    getList()
  } finally {
    refreshing.value = false
  }
}

const getIntegralCentreInfo = async () => {
  const resData = await getIntegralCentreInfoApi()
  if (resData) {
    integralInfo.value = resData
  }
}

const isRulesPop = ref(false)
const integralRules = ref({
  integralScene: '',
  effectDay: '',
  integralExchangeRation: 0
})
const getIntegralRule = async () => {
  const resData = await getIntegralRuleApi()
  if (resData) {
    const {
      integral_scene: integralScene,
      effect_day: effectDay,
      integral_exchange_ration: integralExchangeRation
    } = resData
    integralRules.value = {
      integralScene,
      effectDay: effectDay <= 0 ? '立即生效' : effectDay + '天',
      integralExchangeRation: Number(integralExchangeRation),
      expireDesc: resData.expireDesc
    }
  }
}
onMounted(() => {
  getIntegralCentreInfo()
  getIntegralRule()
})

onBeforeMount(() => {
  const defTitle = useRoute().meta?.defTitle
  document.title = defTitle.replace('积分', integralName)
})
</script>
<style lang="less" scoped>
.page-container {
  font-size: 14px;
  padding: 16px 12px;
  .integral-bg {
    position: absolute;
    top: 0;
    left: 0;
  }
  .top-box {
    color: #ab937d;
    .warn-box {
      display: flex;
      align-items: center;
      line-height: 20px;
      .gold-coin {
        padding-right: 5px;
      }
    }
    .integral-balance-box {
      margin-top: 20px;
      padding: 20px 0;
      position: relative;
      background: linear-gradient(171deg, #ffffff 0%, rgba(255, 255, 255, 0.51) 100%);
      border: 1px solid #fff;
      border-radius: 8px;
      // border-image: linear-gradient(177deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.15)) 1 1;
      backdrop-filter: blur(11px);
      .box-title-wrp {
        display: flex;
        font-size: 12px;
        position: absolute;
        line-height: 25px;
        width: 130px;
        top: 0;
        .box-title {
          width: 115px;
          height: 25px;
          background: linear-gradient(176deg, #ffe6d0 0%, #f6cba2 100%);
          color: #7b5b37;
          text-align: center;
          position: absolute;
          top: -1px;
          background: url('../../assets/img/integral_balance_bg.png');
          background-size: cover;
        }
        .suffix-text {
          position: absolute;
          height: 25px;
          right: -20px;
        }
      }
      .has-use-title {
        color: #674219;
        font-size: 12px;
        position: absolute;
        left: 25px;
        top: 10px;
      }
      .balance-box {
        display: flex;
        align-items: center;
        padding-left: 23px;
        // padding-top: 45px;
        padding-top: 18px;
        .balance-count {
          font-size: 32px;
          font-weight: 800;
          color: #ff6060;
          line-height: 32px;
          height: 32px;
        }
      }
      .big-gold-coin {
        position: absolute;
        top: -20px;
        right: 32px;
      }
    }
    .integral-column {
      display: flex;
      text-align: center;
      justify-content: space-between;
      padding: 20px 15px 0;
      line-height: 27px;
      // height: 27px;
      .count {
        color: #674219;
        font-size: 20px;
        font-weight: 500;
      }
    }
  }
  .content-box {
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 20px;
    .list-item-wrp {
      padding: 0 16px;
      .list-item-content {
        border-bottom: 1px solid #f4f4f4;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
        .integral-content-box {
          width: 100%;
          .integral-type-title {
            display: flex;
            align-items: center;
            .integral-box {
              margin-left: auto;
              font-weight: bold;
              font-size: 18px;
              color: #222222;
            }
            .integral-type-text {
              font-size: 16px;
              color: #222;
              margin-right: 10px;
              font-weight: bold;
            }
            .income-type-tag {
              text-align: center;
              width: 48px;
              height: 16px;
              line-height: 16px;
              border-radius: 4px 4px 4px 0;
              font-size: 11px;
            }
            .effect-tag {
              color: #6392eb;
              background: rgba(99, 146, 235, 0.1);
            }
            .not-effect-tag {
              color: #ff6060;
              background: rgba(153, 153, 153, 0.1);
            }
            .checking-tag {
              color: #f09952;
              background: rgba(240, 153, 82, 0.1);
            }
            .success-tag {
              background: rgba(64, 220, 112, 0.1);
              color: #40dc70;
            }
            .refuse-tag {
              background: rgba(153, 153, 153, 0.1);
              color: #999999;
            }
            .back-tag {
              background: rgba(64, 220, 112, 0.1);
              color: #5adea1;
            }
          }

          .order-type-box {
            margin-top: 10px;
            display: flex;
            align-items: center;
          }
          .created-time-box {
            display: flex;
            align-items: center;
            color: #999999;
            font-size: 12px;
            margin: 12px 0;
            .created-time {
              flex: 1;
            }
          }
          .user-info {
            display: flex;
            // justify-content: center;
            align-items: center;
            .user-name {
              margin-left: 4px;
              font-size: 12px;
            }
          }
        }
      }
      .integral-box {
        font-weight: bold;
        font-size: 18px;
        color: #222222;
      }
    }
  }
  .integral-rule-box {
    font-size: 14px;
    padding: 16px;
    .integral-rule-title {
      text-align: center;
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 15px;
    }
    .integral-get-title {
      margin-bottom: 10px;
    }
    .integral-get-type {
      margin-top: 5px;
      display: flex;
      justify-content: space-between;
      // margin-bottom: px;
    }
    .integral-flex {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      // margin-bottom: 10px;
    }
  }
  // background-image: url('/@/assets/img/integral_bg.png');
}
</style>
